import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import FormAddEditWebhook from '../../components/webhooks/FormAddEditWebhook';
import WebhookSecretDialog from '../../components/webhooks/WebhookSecretDialog';

import { useCreateWebhook } from '../../hooks/webhooks/useCreateWebhook';

const CreateWebhook = () => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');
    const navigate = useNavigate();

    const { createWebhookAsync, isCreating } = useCreateWebhook();

    // The secret is held in component state ONLY — never persisted.
    // See ROADMAP_DASHBOARD §11.9 for the reasoning.
    const [secret, setSecret] = useState(null);
    const [createdId, setCreatedId] = useState(null);

    const handleSubmit = async (payload) => {
        try {
            const res = await createWebhookAsync(payload);
            const data = res?.data || {};
            const id = data.id;
            const oneTimeSecret = data.secret;
            setCreatedId(id);
            if (oneTimeSecret) {
                setSecret(oneTimeSecret);
            } else if (id) {
                navigate(`/settings/integrations/webhooks/${id}`);
            } else {
                navigate('/settings/integrations/webhooks');
            }
        } catch {
            // error toast handled by the hook
        }
    };

    const handleSecretClose = () => {
        setSecret(null);
        if (createdId) {
            navigate(`/settings/integrations/webhooks/${createdId}`);
        } else {
            navigate('/settings/integrations/webhooks');
        }
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <Box sx={{ mb: 2 }}>
                <Typography variant="h5" fontWeight={700}>
                    {isArabic ? 'إضافة Webhook جديد' : 'New Webhook'}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {isArabic
                        ? 'حدد الاسم والرابط واختر الأحداث التي تريد متابعتها. بعد الإنشاء سيظهر لك السر مرة واحدة فقط.'
                        : 'Set the name + URL and pick the events to subscribe to. The secret is shown ONCE after creation.'}
                </Typography>
            </Box>

            <FormAddEditWebhook
                mode="create"
                onSubmit={handleSubmit}
                isSubmitting={isCreating}
            />

            <WebhookSecretDialog
                open={Boolean(secret)}
                secret={secret}
                onClose={handleSecretClose}
            />
        </WrapperSection>
    );
};

export default CreateWebhook;
